import { NavLink } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaWhatsapp, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { COMPANY, WA_LINK } from '../../data/data';
import coloredLogo from '../../assets/colored.png';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__top container">

        {/* Brand column */}
        <div className="footer__brand">
          <img src={coloredLogo} alt="AL-AMANAT" className="footer__logo" />
          <p className="footer__tagline">
            Your trusted partner for Hajj, Umrah, air ticketing and worldwide travel — serving Nigeria since over a decade.
          </p>
          <div className="footer__social">
            <a href={COMPANY.facebook}  target="_blank" rel="noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href={COMPANY.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href={WA_LINK} target="_blank" rel="noreferrer" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
          </div>
        </div>

        {/* Quick links */}
        <div className="footer__col">
          <h4 className="footer__col-title">Quick Links</h4>
          <ul className="footer__nav">
            {[
              { to: '/',         label: 'Home' },
              { to: '/services', label: 'Services' },
              { to: '/about',    label: 'About Us' },
              { to: '/contact',  label: 'Contact Us' },
            ].map(({ to, label }) => (
              <li key={to}><NavLink to={to}>{label}</NavLink></li>
            ))}
          </ul>
        </div>

        {/* Services links */}
        <div className="footer__col">
          <h4 className="footer__col-title">Our Services</h4>
          <ul className="footer__nav">
            <li><NavLink to="/services">Hajj Packages</NavLink></li>
            <li><NavLink to="/services">Umrah Packages</NavLink></li>
            <li><NavLink to="/services">Ticket Booking</NavLink></li>
            <li><NavLink to="/services">Hotel Booking</NavLink></li>
            <li><NavLink to="/services">Visa Processing</NavLink></li>
          </ul>
        </div>

        {/* Contact info */}
        <div className="footer__col">
          <h4 className="footer__col-title">Contact Us</h4>
          <ul className="footer__contact">
            <li>
              <FaPhoneAlt className="footer__contact-icon" />
              <span>{COMPANY.phone1}<br />{COMPANY.phone2}</span>
            </li>
            <li>
              <FaEnvelope className="footer__contact-icon" />
              <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
            </li>
            <li>
              <FaMapMarkerAlt className="footer__contact-icon" />
              <span>611 Agege Motor Road, Shogunle, Ikeja, Lagos</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>&copy; {year} {COMPANY.fullName}. All rights reserved.</p>
          <p>Designed by <a href="https://www.jafarscript.xyz/" target="_blank" rel="noreferrer">Jafarscript</a></p>
        </div>
      </div>
    </footer>
  );
}